export const TABLE = {
  PAGE_MAX_SIZE: 25,
};
